export const fileConstants = {
  UPLOAD_FILE: {
    request: "UPLOAD_FILE_REQUEST",
    success: "UPLOAD_FILE_SUCCESS",
    error: "UPLOAD_FILE_FAILURE",
  },
};
